import React from 'react';
import Login from '../components/LoginPage/Login';

function LoginPage() {
    return (
        <div className = 'login'>
            <Login />
        </div>
    )
}



export default LoginPage;